var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenGraphIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_516_3385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.25 6.5625C28.25 9.15234 26.1523 11.25 23.5625 11.25C22.2207 11.25 21.0078 10.6875 20.1582 9.73242L11.3105 14.209C11.3516 14.4668 11.375 14.7305 11.375 15C11.375 15.2695 11.3516 15.5332 11.3105 15.791L20.1582 20.2148C21.0078 19.3125 22.2207 18.75 23.5625 18.75C26.1523 18.75 28.25 20.8477 28.25 23.4375C28.25 26.0273 26.1523 28.125 23.5625 28.125C20.9727 28.125 18.875 26.0273 18.875 23.4375C18.875 22.8691 18.9746 22.2715 19.1621 21.8145L10.625 17.5488C9.78711 18.8379 8.33984 19.6875 6.6875 19.6875C4.09883 19.6875 2 17.5898 2 15C2 12.4102 4.09883 10.3125 6.6875 10.3125C8.33984 10.3125 9.78711 11.1621 10.625 12.4512L19.1621 8.18555C18.9746 7.67578 18.875 7.13086 18.875 6.5625C18.875 3.97383 20.9727 1.875 23.5625 1.875C26.1523 1.875 28.25 3.97383 28.25 6.5625ZM6.63477 17.8125C8.24023 17.8125 9.44727 16.5527 9.44727 15C9.44727 13.4473 8.24023 12.1875 6.63477 12.1875C5.13418 12.1875 3.82227 13.4473 3.82227 15C3.82227 16.5527 5.13418 17.8125 6.63477 17.8125ZM23.5625 3.75C22.0098 3.75 20.75 5.00918 20.75 6.5625C20.75 8.11523 22.0098 9.375 23.5625 9.375C25.1152 9.375 26.375 8.11523 26.375 6.5625C26.375 5.00918 25.1152 3.75 23.5625 3.75ZM23.5625 26.25C25.1152 26.25 26.375 24.9902 26.375 23.4375C26.375 21.8848 25.1152 20.625 23.5625 20.625C22.0098 20.625 20.75 21.8848 20.75 23.4375C20.75 24.9902 22.0098 26.25 23.5625 26.25Z",
    fill: "#61A578"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_516_3385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.25,
    height: 30,
    fill: "white",
    transform: "translate(2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenGraphIcon);
export default __webpack_public_path__ + "static/media/open-graph-icon.47345608a0eef208b0781df702f68013.svg";
export { ForwardRef as ReactComponent };